import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions({ sendLinkClickToGtm: 'Tracking/sendLinkClickToGtm' }),
    trackParent() {
      if (this.$parent.row) {
        this.sendLinkClickToGtm(this.$parent.row)
      }
    }
  }
}
